// import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import Box from '../../layout/Box';
import {APP_ROOT} from 'signoxe/constants/config'
import './styles.scss';
import getOptions from 'signoxe/utils/tusOptions'
import Icon from 'signoxe/components/widgets/Icon'


const tus = require('tus-js-client');


class UploadBox extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      progress: 0,
      max: 100,
      isRunning: false,
      done: false
    }

    this.upload = null;
  }

  static propTypes = {
    key: PropTypes.string.isRequired,
    data: PropTypes.object.isRequired
  };

  handleError(upload, self) {
    function inner(error) {
      self.setState({ isRunning: false })
      if (error.originalRequest) {
        if (window.confirm("An Error occured while uploading file" + "\nDo you want to retry?")) {
          upload.start();
          self.setState({ isRunning: true })
          return;
        }
      } else {
        window.alert("Upload failed, you can retry by clicking the resume button");
      }
    }

    return inner
  }

  handleProgress(setState) {
    function progress(bytesUploaded, bytesTotal) {
      var percentage = (bytesUploaded / bytesTotal * 100).toFixed(2);
      setState({ progress: percentage });
    }
    return progress
  }

  handleSuccess(setState) {
    function success() {
      setState({ done:true })
    }
    return success
  }

  pause() {
    this.upload.abort()
    this.setState({ isRunning: !this.state.isRunning })
  }

  resume() {
    this.upload.start()
    this.setState({ isRunning: !this.state.isRunning })
  }

  abort(){
    this.upload.abort()
    this.setState({ isRunning: !this.state.isRunning, progress: this.state.max })
    const req = this.upload._openRequest('DELETE', this.upload.url)
    req.send()
      .then((data)=>{
        localStorage.removeItem(this.upload._urlStorageKey)
      })
      .catch((error)=>alert('An error occured while aborting the upload.'))
  }

  componentDidMount() {
    const { data: { file, type }, auth } = this.props;
    const upload = new tus.Upload(file, getOptions(
      auth.token, file))
    upload.options.onError = this.handleError(upload, this)
    upload.options.onSuccess = this.handleSuccess(this.setState.bind(this))
    upload.options.onProgress = this.handleProgress(this.setState.bind(this))
    this.upload = upload;
    if (type === 'fresh') {} else if (type === 'resume') {
      upload.resumeFromPreviousUpload(this.props.data.metadata)
    }
    this.setState({ isRunning: true })
    upload.start()

  }

  checkStatus() {
    const { progress, max, isRunning } = this.state
    if (progress == max) { return } else if (isRunning) {
      return <Icon disabled={progress == max} onClick={this.pause.bind(this)} size='20px' name='pause-circle'/>
    } else { return <Icon disabled={progress == max} onClick={this.resume.bind(this)} size='20px' name='play-circle'/> }
  }


  render() {
    const { data } = this.props;
    const { progress, max, isRunning, done } = this.state
    return (
      <div>
            <h6 className='header'>{data.file.name}</h6>
            {progress && <progress value={progress} max={max}/>}
            <div>
            {this.checkStatus()}
            {!done ? (
              progress == max ?
              <Icon onClick={this.resume.bind(this)} size='20px' name='check-circle-o'/> :
              <Icon onClick={this.abort.bind(this)} size='20px' name='ban'/>
            ): ''}
            </div>
          </div>
    )
  }
}

export default UploadBox;



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/widgets/ResumableBox/UploadBox.js